import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Gift } from 'images/latest'

const GiftIcon = () => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56' }}
    SVG={Gift}
  />
)

export default GiftIcon
